import React from 'react'
import { T } from 'components/Translations'
import { TITLES } from 'common/constants'
import { useSelector } from 'react-redux'

const Title = () => {
  const path = useSelector(s => s.router.location.pathname)
  const translations = useSelector(s => s.translations)
  const lc = useSelector(s => s.account.main?.lc || 0)

  if (TITLES[path]) {
    return <T as="h1" className="section-title" label={TITLES[path]} />
  }

  return <h1 className="section-title">{translations.page[`${path}.${lc}`]?.heading}</h1>
}

export default Title
